import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { useState, useRef, useEffect } from 'react';
import Select from "react-select";

import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Edit = ({ show, onClose, id, refresh, data, val }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const handleSubmit = () => {
        
        if(val === "Auth"){
            const postData = {
                status: 1,
            }
            axios.put(`${baseURL}/payment/update_subscription_refund/${id}`, postData)
                .then(response => {
                    onClose();
                    refresh();
                    toast.success("Refund Updated Successfully!");
                }).catch(error => {
                    onClose();
                    console.log(error);
                    toast.error("Refund Updation Failed");
                });
        } else if(val === "Acc"){
            const postData = {
                status: 1,
            }
            axios.put(`${baseURL}/payment/acc_update_subscription_refund/${id}`, postData)
                .then(response => {
                    onClose();
                    refresh();
                    toast.success("Refund Updated Successfully!");
                }).catch(error => {
                    onClose();
                    console.log(error);
                    toast.error("Refund Updation Failed");
                });
        }
    };


    return (
        <>
            <Modal show={show} size="md">
                <div className="modal-content">
                    <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                        <h3 className="modal-title text-white">Approve Refund</h3>
                        <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                            <span className="text-white">×</span>
                        </Button>
                    </div>
                    <div className="modal-body">
                        <div className='row'>

                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Subscriber</label>
                                <label className='text-black fs-6 font-w500'>{data.subscriber_name}</label>
                            </div>

                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
                                <label className='text-black fs-6 font-w500'>{data.subscriber_number}</label>
                            </div>

                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Subscription Start Date</label>
                                <label className='text-black fs-6 font-w500 text-break'>{data.formatted_start_date}</label>
                            </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Subscription End Date</label>
                                <label className='text-black fs-6 font-w500'>{data.formatted_end_date}</label>
                            </div>

                        </div>

                        <div className="row mb-2">
                            <label className="col-12 text-gray-800 font-w500 fs-7">Reason </label>
                            <label className="col-12 text-black fs-6 font-w500">&emsp;&emsp; {data.refund_reason ? data.refund_reason : '-'}</label>
                        </div>
                        <div className="row mb-2">
                            <label className="col-12 text-gray-800 font-w500 fs-7">Refund Amount </label>
                            <label className="col-12 text-danger fs-4 fw-bold font-w500">&emsp;&emsp; <i className="fa-solid fa-indian-rupee-sign me-2"></i> {data.refund_amont_formatted}</label>
                        </div>

                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                            <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Approve Refund <i className="fas fa-angle-double-right ms-2"></i></Link>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}
export default Edit;